import { render, staticRenderFns } from "./contact-form-panel.vue?vue&type=template&id=1b0df4a3&"
var script = {}
import style0 from "../../../assets/styles/panels/_ContactFormPanel.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports